/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import { BodySmall } from "../atoms/Bodies"
import React from "react"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { Paths } from "../../../utils/Paths"
import { H3 } from "@carrotfertility/carotene"
import { FormattedMessage } from "react-intl"

export const RefreshCarrotPlanModule = () => (
  <RoundedRectangle id="home-sidebar-carrot-plan-module" backgroundColor="light-gray">
    <H3 variant="primary" stack="tiny">
      <FormattedMessage defaultMessage="Has anything changed?" />
    </H3>
    <BodySmall color="black-80">
      <FormattedMessage defaultMessage="Send us an update and we'll refresh your Carrot Plan with new suggestions." />
    </BodySmall>
    <Spacer height={1.5} />
    <ArrowLink to={Paths.REFRESH_CARROT_PLAN}>
      <FormattedMessage defaultMessage="Get new suggestions" />
    </ArrowLink>
  </RoundedRectangle>
)
